import React, {Fragment, useRef, useState} from 'react';
import Loader from './Loader';
import {Form, Field} from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import {connect} from 'react-redux';


function FormComponent(props){
  let errors=useRef();
  let current_value=useRef();
  const[loading, setLoading]=useState(false);

  const required_message='This field is required.'
  if(props.form_completed==true){if(props.loader==true && loading==true){setLoading(false);} props.handleClose(); props.formCompleted(false);}
  if(props.form_error!=undefined){if(props.loader==true && loading==true){setLoading(false);}
    if(props.form_error.data!=undefined && props.form_error.data.message=='The given data was invalid.'){
      for(let key in props.form_error.data.errors){
        if(errors.current==undefined){errors.current={}}
        let key_array=key.split('.');
        let arr=errors.current; let index=1; for(let k of key_array){let n_arr=(key_array.length==index)?((props.form_error.data.errors[key][0].includes('required')==true)?required_message:props.form_error.data.errors[key][0]):(arr[k]==undefined)?(isNaN(key_array[index])==false)?[]:{}:arr[k]; arr[k]=n_arr; arr=arr[k]; index+=1;}
      }
      if(props.customErrorHandle!=undefined){errors.current=props.customErrorHandle(errors.current);}
      props.errorTrigger();
      props.setFormError();
    }
  }

  function arrayEmbed(arr, k, index){
    arr=(arr[k]==undefined)?(isNaN(key_array[index])==false)?[]:{}:arr[k];
    return arr;
  }

  if(errors.current!=undefined){console.log(JSON.parse(JSON.stringify(errors.current)), 'PERFECT ERRORS');}


  function validateResolve(value, errors, current_value){
    console.log(errors, 'ERRORS', value);
    if(errors!=undefined && props.fields_depending_on_others!=undefined){
      for(let key in props.fields_depending_on_others){
        if(errors[key]!=undefined && value[props.fields_depending_on_others[key]]==false){delete errors[key];}
      }
    }

    for(let key in errors){
      if(errors[key]!=undefined && typeof errors[key]==='string' && value[key]!=current_value[key]){errors[key]=undefined;}
      else if(errors[key]!=undefined && value[key]!=current_value[key]){if(value[key]==undefined || value[key].js_id!=current_value[key].js_id || value[key].internal_id!=current_value[key].internal_id || value[key].id!=current_value[key].id){errors[key]=undefined;} errors[key]=validateResolve(value[key], errors[key], current_value[key]);}
    }
    return errors;
  }

  return(
    <Fragment>
    <Form
      onSubmit={(pars)=>{
        let docs=pars.upload_documents; delete pars.upload_documents;
        //SERIALISING AFTER THIS LINE IS A MUST OTHERWISE WE LOSE THE FILE.
        let params=JSON.parse(JSON.stringify(pars)); if(props.prepareSubmit!=undefined){params=props.prepareSubmit(params);}
        let ss=JSON.parse(JSON.stringify(params));
        let send=ss;
        if(docs!=undefined){
          send=new FormData();
          let index=0; for(let doc of docs){if(doc.ignore!=true){send.append('document_'+index, doc); index+=1;}}
          send.append('data', JSON.stringify(ss));
          if(index==0){send=params;}
        }
        if(props.loader==true){setLoading(true);}
        props.onSubmit(send)
      }}
      initialValues={props.initialValues}
      mutators={{
        ...arrayMutators
      }}
      keepDirtyOnReinitialize={props.keepDirtyOnReinitialize}
      validate={(value)=>{
        let res=validateResolve(value, errors.current, current_value.current);
        current_value.current=value;
        return res;
      }}
      >
      {props.children}
      </Form>
      {(loading==false)?null:<div style={{position:'absolute', top:'0px', left:'0px', width:'100vw', height:'100vh'}}><Loader loading_message="This operation may take a while" loading={loading}/></div>}
      </Fragment>
  )
}

export default connect(ss,dd)(FormComponent)

function ss(state){
  return{
    form_error:state.account.form_error,
    form_completed:state.account.form_completed
  }
}

function dd(dispatch){
  return{
    setFormError:(val)=>{dispatch({type:'REQUEST_FORM_ERROR', val:val})},
    formCompleted:(val)=>{dispatch({type:'REQUEST_FORM_COMPLETED', val:val})}
  }
}
